<template>
  <div>
    <label class="text-left block" :for="id">
      <slot></slot>
    </label>
    <textarea
      class="w-full rounded-md !shadow w-full
      !border
      border-gray-300
      outline-none
      text-md
      px-3
      py-2
      placeholder-gray-400
      disabled:bg-gray-100"
      v-model="model"
      :id="id"
      @blur="$emit('blur', $event); blurEvent()"
      :disabled="disabled"
      :required="required"
      :placeholder="placeholder"
      :rows="rows"
    >
    </textarea>
    <InputError
      :label="errorLabel" 
      :condition="errorCondition && required && edited"
    />
  </div>
</template>


<script>
import InputError from './InputError.vue'

export default {
  props: {
    value: String,
    rows: Number,
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: String,
    id: String,
    errorLabel: String,
    errorCondition: Boolean,
  },
  components: {
    InputError
  },
  data() {
    return {
      edited: false,
    };
  },
  methods: {
    blurEvent() {
      this.edited = true
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>